import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Modal from "react-modal";
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  content: string;
  date: string;
  RMBiansOfMeeting: number;
  Presentation_Second: number;
  Presentation_First: number;
  Gallery: string;
}

interface MeetingUser {
  id: string;
  name: string;
  designation: string;
  profile: string;
}

const BlogDetails: React.FC = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const { title } = useParams<{ title: string }>();

  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [RMBUsers, setRMBUsers] = useState<MeetingUser[]>([]);
  const [PresentationFirstUsers, setPresentationFirstUsers] = useState<MeetingUser[]>([]);
  const [PresentationSecondUsers, setPresentationSecondUsers] = useState<MeetingUser[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const decodedTitle = title ? decodeURIComponent(title) : '';

  // Fetch news data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(`${api}/auth/news/title/${decodedTitle}`);
        setNewData(response.data);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };
    fetchData();
  }, [decodedTitle, api]);

  // Fetch users for presentations and meetings
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const RMBians = newData.filter(d => d.RMBiansOfMeeting !== 0);
        const First = newData.filter(d => d.Presentation_First !== 0);
        const Second = newData.filter(d => d.Presentation_Second !== 0);

        const RMBData = await Promise.all(RMBians.map(d => axios.get<MeetingUser[]>(`${api}/auth/user/${d.RMBiansOfMeeting}`)));
        const FirstData = await Promise.all(First.map(d => axios.get<MeetingUser[]>(`${api}/auth/user/${d.Presentation_First}`)));
        const SecondData = await Promise.all(Second.map(d => axios.get<MeetingUser[]>(`${api}/auth/user/${d.Presentation_Second}`)));

        setRMBUsers(RMBData.flatMap(res => res.data));
        setPresentationFirstUsers(FirstData.flatMap(res => res.data));
        setPresentationSecondUsers(SecondData.flatMap(res => res.data));
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    if (newData.length > 0) fetchUsers();
  }, [newData, api]);

  // Flatten gallery images for modal & grid
  const allGalleryImages = newData.flatMap(item => item.Gallery.split('&'));

  const openModal = (index: number) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  return (
    <div>
      <Header />

      {/* Hero Section */}
      {newData.map(data => (
        <div
          key={data.id}
          className="w-full h-[451px] relative bg-center bg-cover"
          style={{ backgroundImage: `url(${api}/uploads/Connect,_Collaborate_And_Succeed.png)` }}
        >
          <div className="relative z-10 flex flex-col justify-center items-center h-full py-5">
            <h2 className="text-[#FDBC12] text-[48px] sm:text-[31px] font-bold text-center">{data.title}</h2>
            <p className="text-[#CBD5E0] text-[20px] text-center lg:w-[80%]">{data.content.substring(0, 230)}</p>
          </div>
        </div>
      ))}

      {/* Meetings & Gallery Section */}
      <div className="bg-[#1E2A3A] py-14 px-8 flex flex-wrap gap-8 border-b border-[#465468]">
        {/* Meetings */}
        <div className="lg:w-[48%] w-full">
          {newData.map(item => (
            <div key={item.id}>
              <h2 className="text-[#FDBC12] text-[39px] font-semibold">Meetings</h2>
              <p className="text-[#FFF7D0] text-[20px] font-semibold mt-2">{item.title}</p>
              <ol className="list-decimal text-[#94A2B8] ml-4 mt-4 flex flex-col gap-2">
                {item.content.split('</br>').map((line, idx) => (
                  <li key={idx}>{line}</li>
                ))}
              </ol>
            </div>
          ))}
        </div>

        {/* Gallery */}
        <div className="lg:w-[48%] w-full">
          {allGalleryImages.map((img, index) => (
            <div
              key={index}
              className={`flex w-full mt-5 ${index % 2 === 0 ? 'justify-end' : 'justify-start'}`}
            >
              <img
                className="w-[60%] cursor-pointer"
                src={`${api}/uploads/${img}`}
                alt={`Gallery Image ${index}`}
                onClick={() => openModal(index)}
              />
            </div>
          ))}
        </div>
      </div>

     {/* Presentations Section */}
<div className="bg-[#101729] grid lg:grid-cols-3 md:grid-col-2 gap-4 sm:grid-col-1 py-14 px-8 border-b border-[#465468]">
  {[ 
    { title: 'RMBians of Meeting', users: RMBUsers },
    { title: 'Presentation 1', users: PresentationFirstUsers },
    { title: 'Presentation 2', users: PresentationSecondUsers }
  ].map((section, idx) => (
    <div key={idx} className="mb-8">
      <p className="text-[#FFF7D0] text-[22px] font-semibold mb-4">{section.title}</p>
      <div className="flex flex-wrap gap-4">
        {section.users.map(user => (
          <div 
            key={user.id} 
            className="bg-[#1E2A3A] p-4 rounded-md w-fulwl lg:w-[98%]  flex flex-col items-start"
          >
            <p className="text-[#94A2B8] text-[16px] font-medium">{user.name}</p>
            {user.designation && <p className="text-[#CBD5E0] text-[14px] mt-1">{user.designation}</p>}
          </div>
        ))}
      </div>
    </div>
  ))}
</div>


      {/* Stories From Event and Meetings Gallery */}
<div className="bg-[#1E2A3A] py-[50px] px-[8%]">
  <p className="text-[#F1F4F9] text-[16px] text-center">Stories FROM</p>
  <div className="relative z-10 text-[#FDBC12] text-[39px] font-bold text-center">
    <h2 className="leading-12">Event and Meetings</h2>
  </div>

  {/* Gallery Grid */}
  <div className="flex flex-wrap sm:justify-start justify-center gap-4 mt-6">
    {allGalleryImages.slice(0, 12).map((img, index) => (
      <img
        key={index}
        className="md:w-[23.6%] sm:w-[48%] cursor-pointer"
        src={`${api}/${img}`}
        alt={`Gallery Image ${index}`}
        onClick={() => openModal(index)}
      />
    ))}
  </div>

  {/* Modal for Swiper */}
  <Modal
    isOpen={isOpen}
    onRequestClose={() => setIsOpen(false)}
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50"
    overlayClassName="fixed inset-0 bg-black bg-opacity-80"
  >
    <div className="relative w-[90%] md:w-[70%] lg:w-[50%] bg-white p-5 rounded-lg">
      <button
        className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl"
        onClick={() => setIsOpen(false)}
      >
        ✖
      </button>

      <Swiper
        modules={[Navigation]}
        navigation
        initialSlide={currentIndex}
        className="w-full h-full"
      >
        {allGalleryImages.map((img, index) => (
          <SwiperSlide key={index}>
            <img
              className="w-full h-auto rounded-lg"
              src={`${api}/uploads/${img}`}
              alt={`Gallery Image ${index}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </Modal>

 
</div>

      <Footer />
    </div>
  );
};

export default BlogDetails;
